import React, { useEffect, useRef, useState } from 'react'; //import React Component
import { cloudStore } from '../firebase';
import { collection, query, where, getDocs, updateDoc, doc, increment } from 'firebase/firestore';

export function AllOrder() {
    const [click, setclick] = useState(0)
    const [orderCollection, setorderCollection] = useState([])
    useEffect(() => {
        getDocs(query(collection(cloudStore, "orderInfo"), where("User_Order", "!=", null)))
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => doc.data());
                setorderCollection(data.flatMap(obj => obj.User_Order))
            })
    }, [click]);

    const [ifshow_more, setifshow_more] = useState(false)
    const [showwhich, setshowwhich] = useState(false)
    const show_more = (e) => {
        let value = e.target.dataset.values
        setshowwhich(value)
        if (ifshow_more) {
            setifshow_more(false)
        } else {
            setifshow_more(true)
        }
    }

    const [proCollection, setproCollection] = useState([])
    // Show create
    useEffect(() => {
        getDocs(query(collection(cloudStore, "productData"), where("Product_Information", "!=", null)))
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => doc.data());
                setproCollection(data)
            })
    }, [click]);

    //更新object中的array的一个值
    const makecomplete = async (e) => {
        let clickvalue = click
        setclick(clickvalue + 1)
        let value = e.target.dataset.value
        let values = JSON.parse(e.target.dataset.values);
        let userID = value.split(":&:")[0].trim()
        let time = value.split(":&:")[1].trim()
        let status = value.split(":&:")[2].trim()
        let buyingPower = value.split(":&:")[3].trim()
        let realtime = new Date()
        let day = realtime.getDate();
        let year = realtime.getFullYear();
        let month = realtime.getMonth() + 1;
        let hours = realtime.getHours().toString().padStart(2, '0');
        let minutes = realtime.getMinutes().toString().padStart(2, '0');
        let seconds = realtime.getSeconds().toString().padStart(2, '0');
        let completeDay = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds

        const proExist = await getDocs(query(collection(cloudStore, "orderInfo"), where("userID", "==", userID)));
        const proData = proExist.docs.map(doc => doc.data());
        const userOrderIndex = proData[0].User_Order.findIndex(item => Object.keys(item)[0] === time);
        if (proData.length > 0 && status !== "订单已完成") {
            if (userOrderIndex !== -1) {
                const updatedUserOrder = {
                    [time]: {
                        ...proData[0].User_Order[userOrderIndex][time],
                        status: "订单已完成",
                        completeDay: completeDay
                    }
                };

                if (status !== "订单已完成") {
                    // let record = JSON.parse(sessionStorage.getItem("tobeAccept"))
                    // console.log(values)
                    values.map((item) => {
                        proCollection.map((content) => {
                            const keys = Object.keys(item);
                            const itemName = keys.find((key) => key !== 'price');
                            if (content.Product_Information.proname === itemName) {
                                const docData = {
                                    "Earn": increment(+item[itemName] * item["price"]),
                                    "SellNum": increment(+item[itemName]),
                                    "SellPeople": increment(+1)
                                }
                                updateDoc(doc(cloudStore, "productData", content.Product_Information.proID), docData)
                            }
                        })
                    })

                    const docData2 = {
                        "会员等级.buyingPower": increment(parseInt(buyingPower))
                    }
                    updateDoc(doc(cloudStore, "userData", userID), docData2)
                }

                updateDoc(doc(cloudStore, "orderInfo", userID), {
                    'User_Order': [
                        ...proData[0].User_Order.slice(0, userOrderIndex),
                        updatedUserOrder,
                        ...proData[0].User_Order.slice(userOrderIndex + 1)
                    ]
                })
            }
        }
    }

    //更新object中的array的一个值
    const makesure = async (e) => {
        let clickvalue = click
        setclick(clickvalue + 1)
        let value = e.target.dataset.value
        let value2 = e.target.dataset.values
        sessionStorage.setItem("tobeAccept", value2);

        let userID = value.split(":&:")[0].trim()
        let time = value.split(":&:")[1].trim()
        let status = value.split(":&:")[2].trim()
        const proExist = await getDocs(query(collection(cloudStore, "orderInfo"), where("userID", "==", userID)));
        const proData = proExist.docs.map(doc => doc.data());
        const userOrderIndex = proData[0].User_Order.findIndex(item => Object.keys(item)[0] === time);
        if (proData.length > 0 && status !== "订单已完成") {
            if (userOrderIndex !== -1) {
                const updatedUserOrder = {
                    [time]: {
                        ...proData[0].User_Order[userOrderIndex][time],
                        status: "订单已确认"
                    }
                };

                // if (status === "等待确认") {
                //     let record = JSON.parse(sessionStorage.getItem("tobeAccept"))
                //     record.map((item) => {
                //         proCollection.map((content) => {
                //             const keys = Object.keys(item);
                //             const itemName = keys.find((key) => key !== 'price');
                //             if (content.Product_Information.proname === itemName) {
                //                 const docData = {
                //                     "Earn": increment(+item[itemName] * item["price"]),
                //                     "SellNum": increment(+item[itemName]),
                //                     "SellPeople": increment(+1)
                //                 }
                //                 console.log(docData)
                //                 updateDoc(doc(cloudStore, "productData", content.Product_Information.proID), docData)
                //             }
                //         })
                //     })
                // }
                if (status === "订单已取消") {
                    let record = JSON.parse(sessionStorage.getItem("tobeAccept"))
                    record.map((item) => {
                        proCollection.map((content) => {
                            const keys = Object.keys(item);
                            const itemName = keys.find((key) => key !== 'price');
                            if (content.Product_Information.proname === itemName) {
                                const docData = {
                                    "LeftNum": increment(-item[itemName]),
                                }
                                updateDoc(doc(cloudStore, "productData", content.Product_Information.proID), docData)
                            }
                        })
                    })
                }
                updateDoc(doc(cloudStore, "orderInfo", userID), {
                    'User_Order': [
                        ...proData[0].User_Order.slice(0, userOrderIndex),
                        updatedUserOrder,
                        ...proData[0].User_Order.slice(userOrderIndex + 1)
                    ]
                })
            }
        }
    }

    const [fillReason, setfillReason] = useState(false)
    const [userID, setuserID] = useState("")
    const [time, settime] = useState("")
    const [teststatus, setstatus] = useState("")
    const openreason = (e) => {
        let value = e.target.dataset.value
        let value2 = e.target.dataset.values
        sessionStorage.setItem("tobeDeny", value2);
        let userID = value.split(":&:")[0].trim()
        let time = value.split(":&:")[1].trim()
        let status = value.split(":&:")[2].trim()
        setuserID(userID)
        settime(time)
        setstatus(status)
        if (fillReason) {
            setfillReason(false)
        } else {
            setfillReason(true)
        }
    }

    const openreason2 = (e) => {
        if (fillReason) {
            setfillReason(false)
        } else {
            setfillReason(true)
        }
    }

    const [reason, setreason] = useState("")
    const handleInputChange = (e) => {
        let { value } = e.target
        setreason(value)
        if (reason.trim().length > 0) {
            document.getElementsByTagName("label")[0].style.color = "black"
        }
    }

    const notsure = async (e) => {
        let clickvalue = click
        setclick(clickvalue + 1)
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.style.display = "none" }, 4500);
        let button = document.querySelector(".submit");
        const proExist = await getDocs(query(collection(cloudStore, "orderInfo"), where("userID", "==", userID)));
        const proData = proExist.docs.map(doc => doc.data());
        const userOrderIndex = proData[0].User_Order.findIndex(item => Object.keys(item)[0] === time);
        if (proData.length > 0 && teststatus !== "订单已完成") {
            if (userOrderIndex !== -1) {
                const updatedUserOrder = {
                    [time]: {
                        ...proData[0].User_Order[userOrderIndex][time],
                        status: "订单已取消",
                        reason: reason
                    }
                };

                if (reason.trim().length > 0) {
                    if (teststatus !== "订单已取消") {
                        let record = JSON.parse(sessionStorage.getItem("tobeDeny"))
                        record.map((item) => {
                            proCollection.map((content) => {
                                const keys = Object.keys(item);
                                const itemName = keys.find((key) => key !== 'price');
                                if (content.Product_Information.proname === itemName) {
                                    const docData = {
                                        "LeftNum": increment(item[itemName]),
                                    }
                                    updateDoc(doc(cloudStore, "productData", content.Product_Information.proID), docData)
                                }
                            })
                        })
                    }
                    updateDoc(doc(cloudStore, "orderInfo", userID), {
                        'User_Order': [
                            ...proData[0].User_Order.slice(0, userOrderIndex),
                            updatedUserOrder,
                            ...proData[0].User_Order.slice(userOrderIndex + 1)
                        ]
                    }).then(() => {
                        setreason("")
                        var newDiv2 = document.createElement("div");
                        var text = document.createTextNode(" Finished");
                        newDiv2.classList.add("tips");
                        newDiv2.appendChild(text);
                        newDiv2.style.color = "red"
                        button.after(newDiv2);
                        setTimeout(() => { setfillReason(false) }, 500);
                    })
                    text = document.createTextNode("Wait for Processing. Do not Reflesh the page utill you saw the finish message");
                    newDiv.appendChild(text);
                    button.after(newDiv);
                } else {
                    text = document.createTextNode("Please fillout the important blanks.");
                    newDiv.appendChild(text);
                    button.after(newDiv);
                    if (reason.trim().length === 0) {
                        document.getElementsByTagName("label")[0].style.color = "red"
                    }
                }
            }
        } else {
            text = document.createTextNode("该订单已完成");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    const [search, setsearch] = useState("")
    const handleInputChangeSearch = (e) => {
        let { value } = e.target
        setsearch(value)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            makeSearch();
        }
    };

    const [orderCollectionFinal, setorderCollectionFinal] = useState([])
    const makeSearch = () => {
        if (search.length > 0) {
            let array = orderCollection.filter((content) => {
                return content[Object.keys(content)]["orderID"].includes(search)
            })
            setorderCollectionFinal(array)
        } else {
            setorderCollectionFinal([])
        }
    }

    const itemRef = useRef(null);
    let eachCollection = null
    let avg_eachCollection = null
    let totalIncome = null
    if (orderCollection.length > 0) {
        let eachItem = orderCollection
        if (orderCollectionFinal.length > 0) {
            eachItem = orderCollectionFinal
        }
        eachItem.sort((a, b) => b[Object.keys(b)]["time"] - a[Object.keys(a)]["time"])
            .sort((a, b) => {
                const aStatus = a[Object.keys(a)]["status"];
                const bStatus = b[Object.keys(b)]["status"];

                if (aStatus === "订单已取消" && bStatus !== "订单已取消") {
                    return -1; // put a before b in the sorted array
                } else if (aStatus !== "订单已取消" && bStatus === "订单已取消") {
                    return 1; // put b before a in the sorted array
                } else {
                    return 0; // don't change the order of a and b in the sorted array
                }
            })
            .sort((a, b) => {
                const aStatus = a[Object.keys(a)]["status"];
                const bStatus = b[Object.keys(b)]["status"];

                if (aStatus === "订单已确认" && bStatus !== "订单已确认") {
                    return -1; // put a before b in the sorted array
                } else if (aStatus !== "订单已确认" && bStatus === "订单已确认") {
                    return 1; // put b before a in the sorted array
                } else {
                    return 0; // don't change the order of a and b in the sorted array
                }
            })
            .sort((a, b) => {
                const aStatus = a[Object.keys(a)]["status"];
                const bStatus = b[Object.keys(b)]["status"];

                if (aStatus === "等待确认" && bStatus !== "等待确认") {
                    return -1; // put a before b in the sorted array
                } else if (aStatus !== "等待确认" && bStatus === "等待确认") {
                    return 1; // put b before a in the sorted array
                } else {
                    return 0; // don't change the order of a and b in the sorted array
                }
            })

        let totalPrice_final = 0
        let totalOrder = 0
        eachItem.map((content) => {
            let eachItemFinal = Object.values(content)[0]
            let coupon = eachItemFinal.coupon
            let delivery = eachItemFinal.delivery
            let totalPrice = eachItemFinal.totalPrice
            if (coupon > 0) {
                totalPrice -= coupon
            }
            if (delivery === "商家配送(1$)") {
                totalPrice += 1
            }

            totalPrice_final += parseFloat(totalPrice)
            totalOrder += 1
        })
        avg_eachCollection = parseFloat((totalPrice_final / totalOrder)).toFixed(2)
        totalIncome = parseFloat(totalPrice_final).toFixed(2)

        eachCollection = eachItem.map((content, index) => {
            let eachItemFinal = Object.values(content)[0]
            let orderItem = eachItemFinal.orderItem
            const keys = Object.keys(orderItem[0]);
            const itemName = keys.find((key) => key !== 'price');
            let coupon = eachItemFinal.coupon
            let delivery = eachItemFinal.delivery
            let totalPrice = parseFloat(eachItemFinal.totalPrice).toFixed(2)
            let status = eachItemFinal.status
            let time = eachItemFinal.time.toDate()
            let day = time.getDate();
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let hours = time.getHours().toString().padStart(2, '0');
            let minutes = time.getMinutes().toString().padStart(2, '0');
            let seconds = time.getSeconds().toString().padStart(2, '0');
            let finalDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
            let userName = eachItemFinal.userName
            let userID = eachItemFinal.userID
            let orderID = eachItemFinal.orderID
            let phone = eachItemFinal.phone
            let location = eachItemFinal.location
            let weChat = eachItemFinal.weChat
            let reason = eachItemFinal.reason
            let completeDay = eachItemFinal.completeDay
            if (coupon > 0) {
                totalPrice -= coupon
            }
            if (delivery === "商家配送(1$)") {
                totalPrice += 1
            }

            const item = orderItem.map((item) => {
                const keys = Object.keys(item);
                const itemName = keys.find((key) => key !== 'price');
                return (
                    <p style={{ textAlign: "left" }} key={itemName}>{itemName} * {item[itemName]}</p>
                )
            })
            itemRef.current = item
            return (
                <div className="each" key={time} style={{ padding: "10px", width: "240px" }}>
                    <div className='eachshoworder' >
                        <h3 style={{ textAlign: "left" }}>状态: {status}</h3>
                        {status === "订单已取消" && reason.length > 0 ?
                            <>
                                <p style={{ textAlign: "left" }}>订单取消原因: {reason}</p>
                            </> : null
                        }
                        {status === "订单已完成" && completeDay.length > 0 ?
                            <>
                                <p style={{ textAlign: "left" }}>订单完成时间: {completeDay}</p>
                            </> : null
                        }
                        {ifshow_more === true && index === parseInt(showwhich) ?
                            <>
                                <p style={{ textAlign: "left" }}>商品信息:</p>
                                {itemRef.current}
                                <hr />
                                <p style={{ textAlign: "left" }}>订单号：{orderID}</p>
                                <p style={{ textAlign: "left" }}>用户：{userName}</p>
                                <p style={{ textAlign: "left" }}>用户手机号：{phone}</p>
                                <p style={{ textAlign: "left" }}>用户地址：{location}</p>
                                <p style={{ textAlign: "left" }}>用户微信号：{weChat}</p>
                                <p style={{ textAlign: "left" }}>配送方式：{delivery}</p>
                            </> : null
                        }
                        {ifshow_more === true && index !== parseInt(showwhich) ?
                            <>
                                <p style={{ textAlign: "left" }}>商品信息：{itemName} * {orderItem[0][itemName]}</p>
                            </> : null
                        }
                        {ifshow_more === false ?
                            <>
                                <p style={{ textAlign: "left" }}>用户：{userName}</p>
                                <p style={{ textAlign: "left" }}>配送方式：{delivery}</p>
                                <p style={{ textAlign: "left" }}>商品信息：{itemName} * {orderItem[0][itemName]}</p>
                            </> : null
                        }
                        <span
                            className="material-symbols-outlined show_more"
                            onClick={(e) => show_more(e)}
                            data-values={index}
                            style={{ textAlign: "center" }}>expand_more
                        </span>
                        <p style={{ textAlign: "left" }}>总价格：{totalPrice}$</p>

                        <div
                            className={"button profile_explore"}
                            data-values={JSON.stringify(orderItem)}
                            data-value={userID + ":&:" + finalDate + ":&:" + status}
                            onClick={(e) => makesure(e)}>
                            确认订单
                        </div>
                        <div
                            className={"button profile_explore"}
                            data-values={JSON.stringify(orderItem)}
                            data-value={userID + ":&:" + finalDate + ":&:" + status}
                            onClick={(e) => openreason(e)}>
                            取消订单
                        </div>
                        <div
                            className={"button profile_explore"}
                            data-values={JSON.stringify(orderItem)}
                            data-value={userID + ":&:" + finalDate + ":&:" + status + ":&:" + totalPrice}
                            onClick={(e) => makecomplete(e)}>
                            订单完成
                        </div>
                    </div>
                </div >
            )
        })
    }

    return (
        <div className='collection_content' style={{ marginTop: "50px", height: "850px" }}>
            <div className='h2bg' style={{ height: "130px" }}>
                <h2>All Order</h2>
                <h3 className='exp'>用户平均购买额：{avg_eachCollection}$</h3>
                <h3 className='exp'>总收入：{totalIncome}$</h3>
            </div>
            <div>
                <form className='makeSearch'>
                    <label htmlFor='search'></label>
                    <input
                        type="text"
                        placeholder="搜索订单号"
                        onChange={(e) => { handleInputChangeSearch(e) }}
                        value={search}
                        onKeyDown={(e) => handleKeyDown(e)} />
                </form>
            </div>
            <div className="store">
                {eachCollection}
                {fillReason === true ?
                    <>
                        <div>
                            <div className='forCloseFullSreen' onClick={openreason2}></div>
                            <div className='fillCoupon'>
                                <form>
                                    <div className='fillContent'>
                                        <div>
                                            <label htmlFor="reason">取消原因: </label>
                                            <input
                                                type="text"
                                                id="reason"
                                                placeholder="请填写原因？"
                                                onChange={(e) => { handleInputChange(e) }}
                                                value={reason}
                                            />
                                        </div>
                                        <div
                                            className="button submit"
                                            style={{ margin: "40px auto 0 auto" }}
                                            onClick={(e) => notsure(e)}>Submit</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </> : null
                }
            </div>
        </div>
    );
}